import { getSuggestions, startSearch } from '../actions/publicActions';
import isSearchBoxEmpty from '../selectors/isSearchBoxEmpty';
import { createDefaultSearchStore } from '../store/store';
import { orchestrator } from 'satcheljs';
import {
    removeSuggestionSegmentFromSearchBox,
    removeSuggestionSegmentFromSearchBoxInternal,
    setSelectedSuggestionIndex,
} from '../actions/internalActions';

export default orchestrator(removeSuggestionSegmentFromSearchBox, actionMessage => {
    const scenarioId = actionMessage.scenarioId;

    // Remove segment from the store.
    removeSuggestionSegmentFromSearchBoxInternal(actionMessage.segmentKey, scenarioId);

    // Reset selectedSuggestionIndex since user broke out of arrowing flow.
    setSelectedSuggestionIndex(createDefaultSearchStore().selectedSuggestionIndex, scenarioId);

    /**
     * After suggestion segment pill is removed, check if search box is empty.
     * If search box is not empty, dispatch a startSearch action to initiate
     * search.
     *
     * If search box is empty, dispatch getSuggestions since search box content
     * has changed.
     */
    if (!isSearchBoxEmpty(scenarioId)) {
        startSearch('NonUserAction', scenarioId);
    } else {
        getSuggestions(scenarioId);
    }
});
